import CustomComponent from '../CustomComponent';

export const OVERLAY_MODAL_CLOSE_EVENT = 'overlay-modal-close';
export const OVERLAY_MODAL_OPEN_EVENT = 'overlay-modal-open';
export const OVERLAY_MODAL_DISMISS_EVENT = 'overlay-modal-dismiss';
export const OVERLAY_MODAL_SUBMIT_EVENT = 'overlay-modal-submit';

export class OverlayModal extends CustomComponent {
	static key = 'lta-overlay-modal';

	static get observedAttributes() {
		return ['is-open'];
	}

	get isOpen() {
		return this.getAttribute('is-open') === 'true';
	}

	set isOpen(value) {
		this.setAttribute('is-open', value ? 'true' : 'false');
	}

	attributeChangedCallback(name, oldValue, newValue) {
		super.attributeChangedCallback(name, oldValue, newValue);

		if (name === 'is-open' && oldValue !== newValue && newValue === 'true') {
			this.dispatchEvent(
				new CustomEvent(OVERLAY_MODAL_OPEN_EVENT, {
					bubbles: true,
					composed: true
				})
			);
		}
	}

	emitCloseEvent() {
		this.dispatchEvent(
			new CustomEvent(OVERLAY_MODAL_CLOSE_EVENT, {
				bubbles: true,
				composed: true
			})
		);
	}

	emitDismissEvent() {
		this.dispatchEvent(
			new CustomEvent(OVERLAY_MODAL_DISMISS_EVENT, {
				bubbles: true,
				composed: true
			})
		);
		// Close the modal
		this.isOpen = false;
	}

	emitSubmitEvent() {
		this.dispatchEvent(
			new CustomEvent(OVERLAY_MODAL_SUBMIT_EVENT, {
				bubbles: true,
				composed: true
			})
		);
	}

	handleContentActionClick = (event) => {
		const actionElement = event.target.closest('[data-modal-dismiss], [data-modal-submit]');
		if (!actionElement || !this.contains(actionElement)) return;

		if (actionElement.hasAttribute('data-modal-submit')) {
			this.emitSubmitEvent();
			return;
		}

		event.preventDefault();
		this.emitDismissEvent();
		this.isOpen = false;
	};

	handleBackdropClick = (event) => {
		event.preventDefault();
		this.emitCloseEvent();
	};

	handleKeydown = (event) => {
		if (event.key !== 'Escape' || !this.isOpen) return;
		this.emitCloseEvent();
	};

	render(children) {
		const isOpen = this.isOpen;
		const openClass = isOpen ? 'is-open' : '';

		return `
			<div
				class="lta-overlay-modal__backdrop ${openClass}"
				aria-hidden="${!isOpen}"
				data-overlay-backdrop
			></div>
			<div
				class="lta-overlay-modal ${openClass}"
				role="dialog"
				aria-modal="${isOpen}"
				aria-hidden="${!isOpen}"
				tabindex="-1"
			>
				<div class="lta-overlay-modal__dialog">
					<div class="lta-overlay-modal__content">
						${children}
					</div>
				</div>
			</div>
		`;
	}

	afterRender() {
		document.body.classList.toggle('lta-modal-open', this.isOpen);
		this.removeEventListener('click', this.handleContentActionClick);
		this.addEventListener('click', this.handleContentActionClick);

		const backdrop = this.querySelector('[data-overlay-backdrop]');
		backdrop?.removeEventListener('click', this.handleBackdropClick);
		backdrop?.addEventListener('click', this.handleBackdropClick);

		document.removeEventListener('keydown', this.handleKeydown);
		if (this.isOpen) {
			document.addEventListener('keydown', this.handleKeydown);
		}
	}

	onUnload() {
		document.body.classList.remove('lta-modal-open');
		document.removeEventListener('keydown', this.handleKeydown);
		this.removeEventListener('click', this.handleContentActionClick);
		this.querySelector('[data-overlay-backdrop]')?.removeEventListener('click', this.handleBackdropClick);
	}
}

export default OverlayModal;
